import jwt_decode from "jwt-decode";
import {
  GET_ERRORS,
  SET_CURRENT_USER,
  SET_CIDS,
  USER_LOADING,
  USER_LOADED
} from "./types";
import { clearErrors } from "./errorActions";  // Assure-toi du bon chemin


import api from '../api';
import _ from 'underscore';

// Register User
export const registerUser = (userData) => dispatch => {
  return new Promise((resolve,reject)=>{
    api
      .register(userData)
      .then(res=>{resolve(res)})
      .catch(err =>{
        reportFailed(err,dispatch);
        reject(err);
      });
  });
};

// Login - get user token
export const loginUser = userData => dispatch => {
  dispatch(setUserLoading());
  return api
    .login(userData)
    .then(res => {
      const { token } = res.data;
      saveUserFromToken(token, dispatch);
    })
    .catch(err => {
      reportFailed(err, dispatch);
      return Promise.reject(err); // Ajout important ici
    });
};


// Log user out
export const logoutUser = () => dispatch => {
  localStorage.removeItem("jwtToken");
  api.setAuthToken(false);
  dispatch(setCurrentUser({}));
  dispatch(setCids([]));
};

export const updateUser = (userData) => dispatch => {
  return new Promise((resolve,reject)=>{
    dispatch(setUserLoading());
    api
      .updateUser(userData)
      .then(res => {
        const { token } = res.data;
        saveUserFromToken(token,dispatch);
        resolve(res);
      })
      .catch(err =>{
        reportFailed(err,dispatch);
        reject(err);
      });
  });
};
export const updatePassword = (userData) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(setUserLoading());

    api
      .updatePassword(userData)
      .then(res => {
        //console.log("✅ Réponse API updatePassword :", res);
        dispatch(setUserLoaded());
        resolve(res);
      })
      .catch(err => {
        //console.error("❌ Erreur Axios updatePassword :", err.response ? err.response.data : err);
        reportFailed(err, dispatch);
        reject(err);
      });
  });
};


export const forgotPassword = userData => dispatch => {
  dispatch(setUserLoading());
  api
    .forgotPassword(userData)
    .then(res => {
      window.alert("You should receive an email in order to reset your password. Please check your inbox.")
      dispatch(setUserLoaded());
    })
    .catch(err =>{
      reportFailed(err,dispatch);
    });
};

export const resetPassword = (userData, history) => dispatch => {
  dispatch(setUserLoading());
  api
    .resetPassword(userData)
    .then(res => {
      window.alert("You password is successfully reset.");
      dispatch(setUserLoaded());
      history.push("/sign-in");
    })
    .catch(err =>{
      reportFailed(err,dispatch);
    });
};

export const getCids = () => dispatch => {
  return new Promise ( (resolve,reject)=>{
    api
      .requestCids()
      .then(res => {
        dispatch(setUserLoaded());
        const cids = res.data;
        if(_.isArray(cids)) {
          dispatch(setCids(cids));
          resolve();
        } else {
          reject('Invalid Cids');
        }
      })
      .catch(err =>{
        reportFailed(err,dispatch);
        reject(err);
      });
  })
};


export const addCid = (cid) => dispatch => {
  return new Promise ( (resolve,reject)=>{
    api
      .addCid({name:cid})
      .then(res => {
        dispatch(setUserLoaded());
        resolve();
      })
      .catch(err =>{
        reportFailed(err,dispatch);
        reject(err);
      });
  })
};

export const deleteCid = (cid) => dispatch => {
  return new Promise ( (resolve,reject)=>{
    api
      .deleteCid({cid})
      .then(res => {
        dispatch(setUserLoaded());
        resolve();
      })
      .catch(err =>{
        reportFailed(err,dispatch);
        reject(err);
      });
  })
};

const saveUserFromToken = (token,dispatch) => {
  localStorage.setItem("jwtToken", token);
  // Set token to Auth header
  api.setAuthToken(token);
  // Decode token to get user data
  const decoded = jwt_decode(token);
  // Set current user
  dispatch(setCurrentUser(decoded));
  dispatch(setUserLoaded());
}

const reportFailed = (err,dispatch) => {
  if (err.response && err.response.data && err.response.data.message) 
    err = Error(err.response.data.message);
  console.error(err.message);
  dispatch(setUserLoaded());
  dispatch(getErrors(err));
    // Renvoie explicitement une erreur pour que `catch` dans SignIn fonctionne
    return Promise.reject(err);
}

export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};
export const setCids = cids => {
  return {
    type: SET_CIDS,
    payload: cids
  };
};
export const setUserLoading = () => {
  return {
    type: USER_LOADING
  };
};
export const setUserLoaded = () => {
  return {
    type: USER_LOADED
  };
};


export const getErrors = (error) => {
  return {
    type: GET_ERRORS,
    payload: error
  };
};


